import * as React from 'react';
import classnames from 'classnames';

const PackageQuantity = ({ 'data-t': dataT = 'package-quantity' , className , packageQuantities , item , dropdown ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames([
            'contact-lens-configurator__package-quantity',
            className
        ]),
        "data-t": dataT
    }, packageQuantities.length === 1 ? item : dropdown)
;

export { PackageQuantity as default };
//# sourceMappingURL=PackageQuantity.js.map
